import type { QuoteResponseDto } from '@trellis/api'

import { SendDocumentDialog } from '@/components/documents'
import {
  AlreadySentError,
  useQuoteEmailMutation,
} from '@/hooks/useQuoteEmail/useQuoteEmail'
import { formatCalendarDate, getCurrencyFormatter } from '@/lib/format'

import { QuotePreviewSheet } from './QuotePreviewSheet'

interface SendQuoteDialogProps {
  quote: QuoteResponseDto
  orgName: string
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function SendQuoteDialog({
  quote,
  orgName,
  open,
  onOpenChange,
}: SendQuoteDialogProps) {
  const mutation = useQuoteEmailMutation(quote.id)
  const currencyFmt = getCurrencyFormatter(quote.currency)

  return (
    <SendDocumentDialog
      documentLabel="Quote"
      documentNumber={quote.displayNumber}
      clientEmail={
        (quote.clientSnapshot as { email?: string | null } | null)?.email ?? ''
      }
      sentAt={quote.sentAt}
      orgName={orgName}
      summary={
        <>
          Total:{' '}
          <span className="text-foreground font-medium tabular-nums">
            {currencyFmt.format(quote.total)}
          </span>
          {quote.expiresAt && (
            <>
              {' · '}Expires:{' '}
              <span className="text-foreground font-medium">
                {formatCalendarDate(quote.expiresAt)}
              </span>
            </>
          )}
        </>
      }
      mutation={mutation}
      isAlreadySentError={(caughtError) => caughtError instanceof AlreadySentError}
      renderPreview={(isOpen, onPreviewOpenChange) => (
        <QuotePreviewSheet
          quoteId={isOpen ? quote.id : null}
          onOpenChange={onPreviewOpenChange}
        />
      )}
      open={open}
      onOpenChange={onOpenChange}
    />
  )
}
